import {Component, Input, OnInit} from '@angular/core';
import {
  DxSelectBoxModule,
  DxTextAreaModule,
  DxDateBoxModule,
  DxFormModule
} from 'devextreme-angular';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {ParentComponentApi,ProfileComponent} from "../../profile/profile.component";
import { PersonalinformationService,personalinformation } from '../../../services/personalinformation.service';
import { Configuration } from '../../../../app.constants';
import {EducationaldetailService,EducationalStream,preStudentAddressInfoEdu} from '../../../services/educationaldetail.service'

//tab2
import { GridColumns,EducationalDetails, ProfileService } from '../../../services/profile.service';
import {  ViewChild, Inject, LOCALE_ID, OnDestroy } from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';
import { ReligionService, Religion } from '../../../../registration/services/religion.service';
import { CasteService, BasicCaste, BasicSubCaste } from '../../../../registration/services/Caste.service';
import { ReservationcategoryService, Reservationcategory } from '../../../../registration/services/reservationcategory.service'
import { PhysicaldisabilityService, Physicaldisability } from '../../../../registration/services/physicaldisability.service'
import { personalinformation2,  Occupations, MinorityDataList,PreviousCollegeList } from '../../../services/personalinformation.service';
import { HelperService } from '../../../../shared/services/helper.service';
import { formatDate } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material';


import { CommondocumentsService, preCommonDocumentsInfo, Documents, UsertDetailsStatus } from '../../../services/commondocuments.service'
import { DxPopupComponent } from 'devextreme-angular';
import { ImageUploadService } from '../../../../shared/services/image-upload.service';
import {DashboardService, PreStudentInformationDashBoard,Hallticket} from '../../../services/dashboard.service';
import { SocialreservationService,  preSocialReservationInfo } from '../../../services/socialreservation.service'
import { Socialreservation } from 'src/app/registration/services/socialreservation.service';
import { CourseType, ContactdetailsService ,preStudentAddressInfoNEW} from '../../../services/contactdetails.service';
import {State, StateService} from '../../../../registration/services/state.service';
import {DistrictService, District} from '../../../../registration/services/district.service';
import {TahsilService, Tahsil} from '../../../../registration/services/tahsil.service';


@Component({
  selector: 'studentprofile1',
  templateUrl: './studentprofile1.component.html',
  styleUrls: ['./studentprofile1.component.scss'],
  providers: [DatePipe,ReligionService,
    CasteService,
    ReservationcategoryService,
    PhysicaldisabilityService,EducationaldetailService,
    StateService,DistrictService,TahsilService,ContactdetailsService
  ]

})
export class Studentprofile1Component implements OnInit {
  @Input() parentApi: ParentComponentApi;
  @Input() index:any;
  @ViewChild(DxFormComponent) otherdetailsForm: DxFormComponent;
  @ViewChild(DxFormComponent) contactForm: DxFormComponent;

  personalInformationForm: any=[];
  
  lastName:any;
  fistName:any;
  middleName:any;
  birthdate:any;   
  data:any;
  LanguageLabel:any;
  prefixdata = [
    { StudentTitle : 'Mr.' },
    { StudentTitle : 'Mrs.' },
    { StudentTitle : 'Ms.' }]
  genderdata = [{genderID:"M",gender:"Male"},{genderID:"F",gender:"Female"},{genderID:"T",gender:"Transgender"}];

  //tab2
@Input() educationalDetailDataNew:preStudentAddressInfoEdu;
    
  
  personalInformationForm2: personalinformation2;
  personalinformationForm: personalinformation;
  err1:any;
  ReliginData: Religion[];
  CasteData: any;
  CasteData1: BasicCaste[];
  SubCasteData: any;
  ResCatData: Reservationcategory[];
  categories: Reservationcategory[];
  PhyDisData: Physicaldisability[];
  readOnly: boolean = false;
  readOnlycontactDetails:boolean=false;
  isValid: boolean;
  isRegisteredForVoterList: boolean = false;
  subcastedisable: boolean = true;
  tempdata: any;
  RegisteredForVoterList: string = "N";
  RegisteredForVoter: boolean = false;
  DisabledVoterID: boolean;
  DisabledVisa: boolean = true;
  minDate: Date = new Date();
  hideVisa: boolean = false;
  MinorityData: MinorityDataList;
  MinorityData1: MinorityDataList[];
  SocialResData:Socialreservation;
  TempMinorityData: any;
  datasource: any;
  PreviousCollegeDtl: any;
  objMinority: any;
  objmin: any;
  NextBtnDisabled:boolean=true;
  saveRecordTabFristDisabled:boolean=false;
  saveRecordTabSecondDisabled:boolean=true;
  public errorMessage: string[] = new Array();
  public Minoritydisable: boolean = true;
  occupations: any;
  occupations1: Occupations[];
  othercastdisable:boolean=true;
  castname:string;
  category:string;
  castdisable:boolean=true;
  ReservationCategoryDisable:boolean=false;
  PhDisdisable:boolean=false;
  StringPattern: any =/^[a-zA-Z ]+$/; 
  namePattern: any = /^[^0-9]+$/;
  Pattern1: any =/^[^<>]+$/;
  PatternAadharNo:any = /^[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$/;
  obj:any;
  areaTypes = [
    { AreaID: 1, AreaName: 'URBAN' },
    { AreaID: 2, AreaName: 'RURAL' },
    { AreaID: 3, AreaName: 'TRIBAL'}
  ];
  maritalStatus = [
    { MaritalStatusID: "S", MaritalStatusName: 'SINGLE' },
    { MaritalStatusID: "M", MaritalStatusName: 'MARRIED' }
  ];
  nationality = [
    { NationalityID: "I", NationalityName: 'INDIAN' },
    { NationalityID: "F", NationalityName: 'FOREIGNER' }
  ];
  MinorityTypedata = [
    { MinorityTypeID: "L", MinorityType: 'LINGUISTIC' },
    { MinorityTypeID: "R", MinorityType: 'RELIGIOUS' }
  ];
  prefixdataFather = [
    { FatherTitle: 'mr.' },
    { FatherTitle: 'mrs.' },
    { FatherTitle: 'ms.' }]

  prefixdataMother = [
    { MotherTitle: 'mr.' },
    { MotherTitle: 'mrs.' },
    { MotherTitle: 'ms.' }]

  SaveBtnDisabled: boolean = false;
  bloodGroups = [
    { StudentBloodGroup: 'A+' },
    { StudentBloodGroup: 'A-' },
    { StudentBloodGroup: 'B+' },
    { StudentBloodGroup: 'B-' },
    { StudentBloodGroup: 'AB+' },
    { StudentBloodGroup: 'AB-' },
    { StudentBloodGroup: 'O+' },
    { StudentBloodGroup: 'O-' }

  ];

  phoneRules: any = {
    SSC: /[02-9]/
  }
phonePattern: any = /^\+\s*1\s*\(\s*[02-9]\d{2}\)\s*\d{3}\s*-\s*\d{4}$/;

  //edu tab

  dataSource: any;
  dataSourceDoc:any;
  dataSourcetemp:any;
  TempEdudata:any;
  columns: GridColumns[];
  popupVisible = false;
  popupVisibleDoc=false;
  popupTitle:string;
  popupTitleViewDoc:string;
  popupTitleedu:string;
  showButton = false;
  public DeleteBtnDisabled:boolean;
  public errormsg;
  educationalDetailData: any;
  tenYear:number=0;
  ReservationCategoryID:number;
  StudentCastID:number;
  //doc tab
  @ViewChild("dxPopUpVar") dxPopup: DxPopupComponent;
  commonDocument: any;
  Documents: Documents[];
  customObj: any;
  StudentDocumentsData: preCommonDocumentsInfo;
  PreStudentDocuments: preCommonDocumentsInfo;
  dataTemp: any;

  value: any[] = [];
  urlDoc: string;


  //FileUpload Changes

  fileUploadErrorMessage: string;
  filesToUpload: Array<File>;
  selectedFileNames: string[] = [];
  public isLoadingData: Boolean = false;
  uploadResult: any;
  res: Array<string>;
  documentId: string;

  popupVisible1 = false;
  popupVisible2 =false;
  popupVisible3 =false;
  popupVisibleedu=false;
  public RemoveFileData :any;
  data1 :any;
  msg:string;
  showButtons:boolean=true;
  showButtons1:boolean;
  printdis:any;
  form1:any;
  profilelink:any;
  YesBtnDisabled:boolean=false;
  loadIndicatorVisible:boolean=false;
  CompDocs:any=[];
  PhysicalDisability: any;
  PreviousExamCategory: any;
  ReservationCategory: any;
  SpecialConsiderations:any;
  ApprovedFlag :any;
  CommonDocumentStatusFlag:any;
  columns1: any;
  gotoadmissiondisable:boolean=true;

  preStudentAddressInfo:preStudentAddressInfoNEW;  
  CorrespondenceAddressCheckbox: boolean = false;
  isEditable: boolean = true;
  district: any;
  tahsil: any;
  states: any;

  districtlocal: any;
  tahsillocal: any;
  stateslocal: any;

  contactDetails:preStudentAddressInfoNEW;
  StateID:number;
  StudentDistrictID:number;
  TahasilID:number;
  StudentLocalStateID:number;
  StudentLocalDistrictID:number;
  StudentLocalTahsilID:number;

  StudentAddress1 : string;
  StudentLocalAddress : string;
  StudentCity : string;
  StudentLocalCity : string;
  StudentPinCode : string;
  StudentLocalPincode : string;
  ForeignAddress:string;
  ForeignCountry:string;
  ForeignCity:string;
  newBindList:any;
  ForeignCountries:any;
  DisabledCorr:boolean=false;

  AddressLabel:string="Permanent Address";
  isPermanent:boolean=true;
  DisabledFore:boolean=true;
  NUMBER_REGEXP = /^-?[\d.]+(?:e-?\d+)?$/;
  coursetypeData:any;
  CourseTypeID:number;

  constructor(private http:HttpClient, private router: Router,private PersonalinformationService: PersonalinformationService, public datepipe: DatePipe
    ,private castService: CasteService,
    private religionService: ReligionService,
    private reservationCategoryService: ReservationcategoryService,
    private physicaldisabilityService: PhysicaldisabilityService,
    private HelperService: HelperService,private EducationaldetailService:EducationaldetailService,
    private CommondocumentsService: CommondocumentsService,
    private Configuration: Configuration,
    private dashboardService:DashboardService,
    private imageService: ImageUploadService,
    private profileService:ProfileService,
    private Router:Router,
    private SocialreservationService: SocialreservationService,
    private ContactdetailsService:ContactdetailsService,
    private stateService: StateService,
    private DistrictService: DistrictService,
    private TahsilService: TahsilService,
    ) {
    this.columns1 = profileService.getCommonDocumentGridColumns();
  }

  ngOnInit() {
    
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    this.ContactdetailsService.GetBasicCourseTypeList()
    .subscribe((data: CourseType[]) => this.coursetypeData = data,
      error => {
        alert(error);
      },
      () => {
        this.fillformdata();
      });
      
    //tab2
    
    this.educationalDetailData = {
      StudentOtherInfoID:null,
      StudentID:null,
      PreviousExamID:null,
      PreQualifiedCourseID :null,
      PreQualifiedBranchID :null,
      PreExamUniversityID:null,
      PreviousExamMonth:null,
      PreviousExamYear:null,
      PreviousExamPercentage:null,
      PreviousExamSeatNo:null,
      PreviousGrade:null,
      EducationalStreamID:null,
      EduStrmOtherInfo:null,
      PreviousCollegeSchoolName:null,
      PreviousExamName :null,
      Maxmarks :null,
      Obtmarks :null,
      StudentType :null,
      CreatedLoginID:null,
      UpdatedLoginID:null,
      PreStudentUGDetailsList:[{
      YearTotalObtain:0,
      YearTotalMax:0,
      SpeciTotalObtain:0,
      SpeciTotalMax:0,
      }]
    };
  }
  fillformdata(){
    
    this.religionService.getAllReligion()
    .subscribe((data: Religion[]) => this.ReliginData = data,
      error => {
        alert(error);
      },
      () => {

        this.PersonalinformationService.GetAllMinorityList()
            .subscribe((data: MinorityDataList[]) => this.TempMinorityData = data,
              error => {
                alert(error);
              },
              () => {
                this.MinorityData = this.TempMinorityData;
                  this.PersonalinformationService.GetStudentUniversityType()
                  .subscribe((data: PreviousCollegeList[]) => this.datasource = data,
                    error => {
                      alert(error);
                    },
                    () => {
                      this.PreviousCollegeDtl = this.datasource; 
                        this.SocialreservationService.GetSocialReservationInfo(this.Configuration.StudentID)
                          .subscribe((data: preSocialReservationInfo[]) => this.datasource = data,
                            error => {
                              alert(error);
                            },
                            () => {
                              this.SocialResData = this.datasource; 
                                this.reservationCategoryService.getAllReservationcategoryList()
                                .subscribe((data: Reservationcategory[]) => this.categories = data,
                                  error => {
                                    alert(error);
                                  },
                                  () => {
                                    this.GetPersonalInformation();
                                    }
                                  );
                              });
                        });
                      });

      });
  }
  GetPersonalInformation() {
    if (this.Configuration.StudentID > 0) {
      this.NextBtnDisabled = false;
      this.PersonalinformationService.GetPreStudentInformationListByIDForPortalNEW(this.Configuration.StudentID,this.Configuration.StudentProfileLock)
        .subscribe((data: personalinformation[]) => this.data = data,
          error => {
            alert(error);
          },
          () => {
            debugger;
            this.personalInformationForm2 = this.data[0];
            this.castdisable=true;
            //this.ReservationCategoryDisable=true;
            this.Configuration.StudentProfileLock=this.data[0].ProfileLockStatusFlag;
            if(this.Configuration.StudentProfileLock=="Y"){
              this.readOnly=true;   
              this.saveRecordTabFristDisabled  =true;
              this.saveRecordTabSecondDisabled  =true; 
              this.SaveBtnDisabled=true; 
              this.NextBtnDisabled=false;
            } 
            else{
              this.readOnly=false;
              this.saveRecordTabFristDisabled=false;
              this.saveRecordTabSecondDisabled  =false;
              this.NextBtnDisabled=true;
              this.SaveBtnDisabled=false;
            }

            this.ReservationCategoryID =this.personalInformationForm2.ReservationCategoryID;
            this.StudentCastID =this.personalInformationForm2.StudentCastID;

            this.CourseTypeID = this.data[0].CourseTypeID;
            if(this.CourseTypeID ==0 || this.CourseTypeID ==undefined || this.CourseTypeID ==null){
            }else{
              //this.getdata();
            }
            
          });
    } else {
      this.NextBtnDisabled = true;
      this.PersonalinformationService.GetPortalStudentLogInListInsertPreStudentInformation(this.Configuration.StuPoartlaID)
        .subscribe((data: personalinformation2[]) => this.data = data,
          error => {
            alert(error);
          },
          () => {debugger
            this.personalInformationForm2 = this.data[0];
            this.personalInformationForm2.NationalityFlag = 'I';
            
            this.personalInformationForm2.StudentID = this.data[0].StudentID;
            this.Configuration.StudentID = this.data[0].StudentID;
            this.personalInformationForm2.StudentTitle = this.data[0].StudentTitle;
            this.personalInformationForm2.StudentLastName = this.data[0].LastName;
            this.personalInformationForm2.StudentFirstName = this.data[0].FirstName;
            this.personalInformationForm2.StudentMiddleName = this.data[0].MiddleName;
            this.personalInformationForm2.StudentName = this.data[0].Name;
            this.personalInformationForm2.StudentMothersName = this.data[0].StudentMothersName;
            this.personalInformationForm2.StudentSexCode = this.data[0].StuGender;
            this.personalInformationForm2.StudentBirthDate = this.data[0].StudentBirtHDate;
            this.personalInformationForm2.StudYear = this.data[0].StudYear;
            this.personalInformationForm2.StudentMobileNo = this.data[0].MobileNo;
            this.personalInformationForm2.StudentMailID = this.data[0].StudeMailId;
            this.personalInformationForm2.PRNNO=this.data[0].PRNNO;
            this.personalInformationForm2.StudentRegType=this.data[0].StudentRegType;
            if(this.CourseTypeID ==0 || this.CourseTypeID ==undefined || this.CourseTypeID ==null){
            }else{
              //this.getdata();
            }
          });
    }
    this.getcontactDetails();
    
  }

  getcontactDetails(){
    this.contactDetails =null;    
    this.stateService.getAllState()
    .subscribe((data: State[]) => this.states = data,
      error => {
        alert(error);
      },
      () => {
        this.stateslocal =  this.states;
        if (this.Configuration.StudentID > 0)
        {
          this.getcontactdata();
        }
        else
        {
          this.contactDetails = null;
        }
      }); 
  }
  getcontactdata(){
    this.ContactdetailsService.GetContactinfo(this.Configuration.StudentID)
    .subscribe((data: preStudentAddressInfoNEW[]) => this.datasource = data,
      error => {
        alert(error);
      },
      () => {
        this.contactDetails = this.datasource[0];
        if(this.contactDetails ==undefined) {
           this.newBindList = [];
           this.customObj=[];
           this.customObj.StudentID = this.Configuration.StudentID;
           this.newBindList.push(this.customObj);
           this.contactDetails = this.newBindList;
        }
        if(this.contactDetails.StateID ==0){
          this.StateID = this.states[0].StateID;
        }
        else{
          this.StateID = this.contactDetails.StateID;
        }
        if(this.contactDetails.StudentLocalStateID ==0){
          this.StudentLocalStateID = this.stateslocal[0].StateID;
        }else{
          this.StudentLocalStateID = this.contactDetails.StudentLocalStateID;
        }
        this.StudentDistrictID = this.contactDetails.StudentDistrictID;
        this.TahasilID = this.contactDetails.TahasilID;
        this.StudentLocalDistrictID = this.contactDetails.StudentLocalDistrictID;
        this.StudentLocalTahsilID = this.contactDetails.StudentLocalTahsilID;
        if(this.contactDetails.NationalityFlag =="I" || this.contactDetails.NationalityFlag ==null) {
          this.DisabledCorr =false;
          this.DisabledFore =true;
        }else {
          this.DisabledCorr =true;
          this.DisabledFore =false;
        }  
        if((this.contactDetails.StudentLocalAddress ===  this.contactDetails.StudentAddress1) &&
          (this.contactDetails.StudentLocalStateID === this.contactDetails.StateID) &&
          (this.contactDetails.StudentLocalDistrictID === this.contactDetails.StudentDistrictID) &&
          (this.contactDetails.StudentLocalTahsilID === this.contactDetails.TahasilID) &&
          (this.contactDetails.StudentLocalCity === this.contactDetails.StudentCity) &&
          (this.contactDetails.StudentLocalPincode === this.contactDetails.StudentPinCode)
          )
          {
            this.contactDetails.CorrespondenceAddressCheckbox=true;
          }
      }); 
  }

  saveFristTab() {
    debugger
    
    this.personalInformationForm2.StudentID = this.Configuration.StudentID;
    if((this.CourseTypeID==null || this.CourseTypeID==undefined || this.CourseTypeID==0)){
      this.HelperService.showWarningMessage("Please select Program Type and submit");
      return;
    }
    if((this.personalInformationForm2.StudentLastName==null || this.personalInformationForm2.StudentLastName==undefined || this.personalInformationForm2.StudentLastName=="")){
      this.HelperService.showWarningMessage("Please Enter Last Name");
      return;
    }
    if((this.personalInformationForm2.StudentFirstName==null || this.personalInformationForm2.StudentFirstName==undefined || this.personalInformationForm2.StudentFirstName=="")){
      this.HelperService.showWarningMessage("Please Enter First Name");
      return;
    }
    if((this.personalInformationForm2.StudentMiddleName==null || this.personalInformationForm2.StudentMiddleName==undefined || this.personalInformationForm2.StudentMiddleName=="")){
      this.HelperService.showWarningMessage("Please Enter Middle Name");
      return;
    }
    if((this.personalInformationForm2.StudentSexCode==null || this.personalInformationForm2.StudentSexCode==undefined || this.personalInformationForm2.StudentSexCode=="")){
      this.HelperService.showWarningMessage("Please Select Gender");
      return;
    }
    if((this.personalInformationForm2.StudentReligionID==null || this.personalInformationForm2.StudentReligionID==undefined || this.personalInformationForm2.StudentReligionID==0)){
      this.HelperService.showWarningMessage("Please Select Religion");
      return;
    }
    this.personalInformationForm2.ReservationCategoryID=this.ReservationCategoryID;
    this.personalInformationForm2.StudentCastID=this.StudentCastID;
    if((this.personalInformationForm2.ReservationCategoryID==null || this.personalInformationForm2.ReservationCategoryID==undefined || this.personalInformationForm2.ReservationCategoryID==0)){
      this.HelperService.showWarningMessage("Please Select Caste Category");
      return;
    } 
    if((this.personalInformationForm2.StudentCastID==null || this.personalInformationForm2.StudentCastID==undefined)){
      this.HelperService.showWarningMessage("Please Select Caste");
      return;
    }
    if((this.personalInformationForm2.MinorityID==null || this.personalInformationForm2.MinorityID==undefined || this.personalInformationForm2.MinorityID==0)){
      this.HelperService.showWarningMessage("Please Select Admission/Minority");
      return;
    }
    if((this.personalInformationForm2.AadharNoID==null || this.personalInformationForm2.AadharNoID==undefined || this.personalInformationForm2.AadharNoID=="")){
      this.HelperService.showWarningMessage("Please Enter Aadhar No.");
      return;
    }
    if((this.personalInformationForm2.StudentType==null || this.personalInformationForm2.StudentType==undefined || this.personalInformationForm2.StudentType=="")){
      this.HelperService.showWarningMessage("Please Select Previous College/School");
      return;
    }
    if((this.personalInformationForm2.SocialReservationID==null || this.personalInformationForm2.SocialReservationID==undefined)){
      this.HelperService.showWarningMessage("Please Select Special/Parallel Category");
      return;
    }
    if(this.personalInformationForm2.OtherCasteName==null || this.personalInformationForm2.OtherCasteName==undefined){
      this.personalInformationForm2.OtherCasteName="";
    }
    if (this.personalInformationForm2.AccountNo == null || this.personalInformationForm2.AccountNo == undefined) {
      this.personalInformationForm2.AccountNo = "";
    }
    if (this.personalInformationForm2.VoterID == null || this.personalInformationForm2.VoterID == undefined) {
      this.personalInformationForm2.VoterID = "";
    }
    if (this.personalInformationForm2.TwoSemDataFlag == null || this.personalInformationForm2.TwoSemDataFlag == undefined) {
      this.personalInformationForm2.TwoSemDataFlag = "";
    }
    if (this.personalInformationForm2.SubCasteID == null || this.personalInformationForm2.SubCasteID == undefined) {
      this.personalInformationForm2.SubCasteID = 0;
    }
    if (this.personalInformationForm2.StudentNameBL == null || this.personalInformationForm2.StudentNameBL == undefined) {
      this.personalInformationForm2.StudentNameBL = "";
    }
    if (this.personalInformationForm2.StudentMothersNameBL == null || this.personalInformationForm2.StudentMothersNameBL == undefined) {
      this.personalInformationForm2.StudentMothersNameBL = "";
    }
    if (this.personalInformationForm2.SportsID == null || this.personalInformationForm2.SportsID == undefined) {
      this.personalInformationForm2.SportsID = "";
    }
    if (this.personalInformationForm2.ReasonOfNameChange == null || this.personalInformationForm2.ReasonOfNameChange == undefined) {
      this.personalInformationForm2.ReasonOfNameChange = "";
    }
    if (this.personalInformationForm2.PreviousNameOfStudent == null || this.personalInformationForm2.PreviousNameOfStudent == undefined) {
      this.personalInformationForm2.PreviousNameOfStudent = "";
    }
    if (this.personalInformationForm2.OtherPRN == null || this.personalInformationForm2.OtherPRN == undefined) {
      this.personalInformationForm2.OtherPRN = "";
    }
    if (this.personalInformationForm2.IdentiMark2 == null || this.personalInformationForm2.IdentiMark2 == undefined) {
      this.personalInformationForm2.IdentiMark2 = "";
    }
    if (this.personalInformationForm2.IdentiMark1 == null || this.personalInformationForm2.IdentiMark1 == undefined) {
      this.personalInformationForm2.IdentiMark1 = "";
    }
    if (this.personalInformationForm2.IFSCcode == null || this.personalInformationForm2.IFSCcode == undefined) {
      this.personalInformationForm2.IFSCcode = "";
    }
    if (this.personalInformationForm2.HobbyID == null || this.personalInformationForm2.HobbyID == undefined) {
      this.personalInformationForm2.HobbyID = "";
    }
    if (this.personalInformationForm2.HobbyID == null || this.personalInformationForm2.HobbyID == undefined) {
      this.personalInformationForm2.HobbyID = "";
    }
    if (this.personalInformationForm2.Gender == null || this.personalInformationForm2.Gender == undefined) {
      this.personalInformationForm2.Gender = "";
    }
    if (this.personalInformationForm2.BankName == null || this.personalInformationForm2.BankName == undefined) {
      this.personalInformationForm2.BankName = "";
    }
    if (this.personalInformationForm2.BankBranchName == null || this.personalInformationForm2.BankBranchName == undefined) {
      this.personalInformationForm2.BankBranchName = "";
    }
    if (this.personalInformationForm2.AccountNo == null || this.personalInformationForm2.AccountNo == undefined) {
      this.personalInformationForm2.AccountNo = "";
    }
    if (this.personalInformationForm2.PRNNO == null || this.personalInformationForm2.PRNNO == undefined) {
      this.personalInformationForm2.PRNNO = "";
    }
    if (this.personalInformationForm2.StudentSubCastID == null || this.personalInformationForm2.StudentSubCastID == undefined) {
      this.personalInformationForm2.StudentSubCastID = 0;
    }
    if (this.personalInformationForm2.StudentPhone == null || this.personalInformationForm2.StudentPhone == undefined) {
      this.personalInformationForm2.StudentPhone = "";
    }
    if (this.personalInformationForm2.StudentPassPortNo == null || this.personalInformationForm2.StudentPassPortNo == undefined) {
      this.personalInformationForm2.StudentPassPortNo = "";
    }
    if (this.personalInformationForm2.StudentDrivingLicenceNo == null || this.personalInformationForm2.StudentDrivingLicenceNo == undefined) {
      this.personalInformationForm2.StudentDrivingLicenceNo = "";
    }
    if (this.personalInformationForm2.ReligionOtherDetl == null || this.personalInformationForm2.ReligionOtherDetl == undefined) {
      this.personalInformationForm2.ReligionOtherDetl = "";
    }
    if (this.personalInformationForm2.AccountNo == null || this.personalInformationForm2.AccountNo == undefined) {
      this.personalInformationForm2.AccountNo = "";
    }
    if (this.personalInformationForm2.VoterID == null || this.personalInformationForm2.VoterID == undefined) {
      this.personalInformationForm2.VoterID = "0";
    }
    if (this.personalInformationForm2.TwoSemDataFlag == null || this.personalInformationForm2.TwoSemDataFlag == undefined) {
      this.personalInformationForm2.TwoSemDataFlag = "";
    }
    if (this.personalInformationForm2.SubCasteID == null || this.personalInformationForm2.SubCasteID == undefined) {
      this.personalInformationForm2.SubCasteID = 0;
    }
    if (this.personalInformationForm2.StudentNameBL == null || this.personalInformationForm2.StudentNameBL == undefined) {
      this.personalInformationForm2.StudentNameBL = "";
    }
    if (this.personalInformationForm2.StudentMothersNameBL == null || this.personalInformationForm2.StudentMothersNameBL == undefined) {
      this.personalInformationForm2.StudentMothersNameBL = "";
    }
    if (this.personalInformationForm2.SportsID == null || this.personalInformationForm2.SportsID == undefined) {
      this.personalInformationForm2.SportsID = "";
    }
    if (this.personalInformationForm2.ReasonOfNameChange == null || this.personalInformationForm2.ReasonOfNameChange == undefined) {
      this.personalInformationForm2.ReasonOfNameChange = "";
    }
    if (this.personalInformationForm2.PreviousNameOfStudent == null || this.personalInformationForm2.PreviousNameOfStudent == undefined) {
      this.personalInformationForm2.PreviousNameOfStudent = "";
    }
    if (this.personalInformationForm2.OtherPRN == null || this.personalInformationForm2.OtherPRN == undefined) {
      this.personalInformationForm2.OtherPRN = "";
    }
    if (this.personalInformationForm2.IdentiMark2 == null || this.personalInformationForm2.IdentiMark2 == undefined) {
      this.personalInformationForm2.IdentiMark2 = "";
    }
    if (this.personalInformationForm2.IdentiMark1 == null || this.personalInformationForm2.IdentiMark1 == undefined) {
      this.personalInformationForm2.IdentiMark1 = "";
    }
    if (this.personalInformationForm2.IFSCcode == null || this.personalInformationForm2.IFSCcode == undefined) {
      this.personalInformationForm2.IFSCcode = "";
    }
    if (this.personalInformationForm2.HobbyID == null || this.personalInformationForm2.HobbyID == undefined) {
      this.personalInformationForm2.HobbyID = "";
    }
    if (this.personalInformationForm2.HobbyID == null || this.personalInformationForm2.HobbyID == undefined) {
      this.personalInformationForm2.HobbyID = "";
    }
    if (this.personalInformationForm2.Gender == null || this.personalInformationForm2.Gender == undefined) {
      this.personalInformationForm2.Gender = "";
    }
    if (this.personalInformationForm2.BankName == null || this.personalInformationForm2.BankName == undefined) {
      this.personalInformationForm2.BankName = "";
    }
    if (this.personalInformationForm2.BankBranchName == null || this.personalInformationForm2.BankBranchName == undefined) {
      this.personalInformationForm2.BankBranchName = "";
    }
    if (this.personalInformationForm2.AccountNo == null || this.personalInformationForm2.AccountNo == undefined) {
      this.personalInformationForm2.AccountNo = "";
    }
    if (this.personalInformationForm2.PRNNO == null || this.personalInformationForm2.PRNNO == undefined) {
      this.personalInformationForm2.PRNNO = "";
    }
    if (this.personalInformationForm2.StudentSubCastID == null || this.personalInformationForm2.StudentSubCastID == undefined) {
      this.personalInformationForm2.StudentSubCastID = 0;
    }
    if (this.personalInformationForm2.GuardianPhoneNo == null || this.personalInformationForm2.GuardianPhoneNo == undefined) {
      this.personalInformationForm2.GuardianPhoneNo = "";
    }
    if (this.personalInformationForm2.PANCardNo == null || this.personalInformationForm2.PANCardNo == undefined) {
      this.personalInformationForm2.PANCardNo = "";
    }
    if (this.personalInformationForm2.FatherTitle == null || this.personalInformationForm2.FatherTitle == undefined) {
      this.personalInformationForm2.FatherTitle = "";
    }
    if (this.personalInformationForm2.FatherFirstName == null || this.personalInformationForm2.FatherFirstName == undefined) {
      this.personalInformationForm2.FatherFirstName = "";
    }
    if (this.personalInformationForm2.FatherMiddleName == null || this.personalInformationForm2.FatherMiddleName == undefined) {
      this.personalInformationForm2.FatherMiddleName = "";
    }
    if (this.personalInformationForm2.FatherLastName == null || this.personalInformationForm2.FatherLastName == undefined) {
      this.personalInformationForm2.FatherLastName = "";
    }
    if (this.personalInformationForm2.MotherTitle == null || this.personalInformationForm2.MotherTitle == undefined) {
      this.personalInformationForm2.MotherTitle = "";
    }
    if (this.personalInformationForm2.MotherMiddleName == null || this.personalInformationForm2.MotherMiddleName == undefined) {
      this.personalInformationForm2.MotherMiddleName = "";
    } 
    if (this.personalInformationForm2.MotherLastName == null || this.personalInformationForm2.MotherLastName == undefined) {
      this.personalInformationForm2.MotherLastName = "";
    }

    if (this.personalInformationForm2.PhysicalDisabilityPercent == null || this.personalInformationForm2.PhysicalDisabilityPercent == undefined) {
      this.personalInformationForm2.PhysicalDisabilityPercent = 0;
    }
    
    if (this.personalInformationForm2.RegisteredForVoter == true) {
      this.personalInformationForm2.VoteReg = "Y";
    } else {
      this.personalInformationForm2.VoteReg = "N";
    }
    if (this.personalInformationForm2.NationalityFlag == "I") {
      this.personalInformationForm2.VisaNumber = "";
      this.personalInformationForm2.VisaValidity = '01/01/1991';
    }
    var str1 = formatDate(this.personalInformationForm2.VisaValidity, 'dd/MMM/yyyy hh:mm:ss', 'en');
    this.personalInformationForm2.VisaValidity = str1;

    this.personalInformationForm2.SubCasteOtherDetl = "";
    this.personalInformationForm2.ReservationID = "";
    this.personalInformationForm2.StudentCategoryID =0;
    this.personalInformationForm2.StudentName = this.personalInformationForm2.StudentFirstName + ' ' + this.personalInformationForm2.StudentMiddleName + ' ' + this.personalInformationForm2.StudentLastName;

    this.personalInformationForm2.CreatedLoginID = this.Configuration.CreatedLoginID;
    this.personalInformationForm2.UpdatedLoginID = this.Configuration.UpdatedLoginID;
    this.personalInformationForm2.RegFormNo = 0;
    this.personalInformationForm2.StudentUIDNo = "";
    this.personalInformationForm2.StudentSecondMailID = "";
    this.personalInformationForm2.Migrated = "";
    this.personalInformationForm2.EmploymentStatus = "";
    this.personalInformationForm2.JoinNssNcc = "";
    this.personalInformationForm2.OrganDonor = "";
    
    this.saveRecordTabFristDisabled=true;

    this.ContactdetailsService.Getcheckadharnoduplicate(this.personalInformationForm2.AadharNoID,this.Configuration.StudentID)
    .subscribe((data: CourseType[]) => this.data1 = data,
      error => {
        alert(error);
      },
      () => {
        debugger;
        if(this.data1.length>0){
          this.HelperService.showWarningMessage("Aadhar No. already exist");
          this.saveRecordTabFristDisabled = false;
          this.saveRecordTabSecondDisabled=true;
          return;
        }else{
          this.PersonalinformationService.updateProfile1(this.personalInformationForm2)
          .subscribe(value => {
            this.onSuccessUpdate();
            this.saveRecordTabFristDisabled = false;
            this.saveRecordTabSecondDisabled=false;
            this.getcontactDetails();
           // this.getdatadoc();
          },
            err => {
              this.errorMessage = this.HelperService.getErrorMessage(err);
              this.HelperService.showSuccessMessage("Not Saved.");
              this.saveRecordTabFristDisabled = false;
              this.saveRecordTabSecondDisabled=true;
            },
            () => {
            });
        }
      }); 


  }
  saveSecondTab(){
    this.isValid = this.contactForm.instance.validate().isValid;
    if(this.isValid==false){
      return;
    }

    this.contactDetails.StateID=this.StateID;
        this.contactDetails.StudentDistrictID=this.StudentDistrictID;
        this.contactDetails.TahasilID=this.TahasilID;
        this.contactDetails.StudentLocalStateID=this.StudentLocalStateID;
        this.contactDetails.StudentLocalDistrictID=this.StudentLocalDistrictID;
        this.contactDetails.StudentLocalTahsilID=this.StudentLocalTahsilID;
        this.contactDetails.StudentID =this.Configuration.StudentID;     
        if(this.contactDetails.NationalityFlag !="I") {
              if(this.contactDetails.ForeignAddress ==null || this.contactDetails.ForeignAddress ==undefined || this.contactDetails.ForeignAddress =="")
              {
                this.HelperService.showWarningMessage("Enter Foreign Address");
                return;
              } 
              if(this.contactDetails.ForeignCountryName ==null || this.contactDetails.ForeignCountryName ==undefined || this.contactDetails.ForeignCountryName =="")
              {
                this.HelperService.showWarningMessage("Enter Foreign Country Name");
                return;
              } 
              if(this.contactDetails.ForeignCityName ==null || this.contactDetails.ForeignCityName ==undefined || this.contactDetails.ForeignCityName =="")
              {
                this.HelperService.showWarningMessage("Enter Foreign City Name");
                return;
              } 
          }
        else{
              if(this.contactDetails.ForeignAddress ==null || this.contactDetails.ForeignAddress ==undefined)
              {
                this.contactDetails.ForeignAddress="";
              } 
              if(this.contactDetails.ForeignCityName ==null || this.contactDetails.ForeignCityName ==undefined)
              {
                this.contactDetails.ForeignCityName="";
              } 
              if(this.contactDetails.ForeignCountryName ==null || this.contactDetails.ForeignCountryName ==undefined)
              {
                this.contactDetails.ForeignCountryName="";
              } 
        }
        if(this.contactDetails.StudentLocalAddress== "" || this.contactDetails.StudentLocalAddress ==null || this.contactDetails.StudentLocalAddress ==undefined)
        {
          this.HelperService.showWarningMessage("Enter Address");
            return;
        } 
        if(this.contactDetails.StudentLocalStateID ==null || this.contactDetails.StudentLocalStateID ==undefined)
        {
          this.HelperService.showWarningMessage("Select State");
            return;
        } 
        if(this.contactDetails.StudentLocalDistrictID ==null || this.contactDetails.StudentLocalDistrictID ==undefined)
        {
          this.HelperService.showWarningMessage("Select District");
            return;
        } 
        if(this.contactDetails.StudentLocalTahsilID ==null || this.contactDetails.StudentLocalTahsilID ==undefined)
        {
          this.HelperService.showWarningMessage("Select Tahsil");
            return;
        } 
        debugger
        if( this.contactDetails.TahasilID ==null || this.contactDetails.TahasilID ==undefined)
        {
          this.contactDetails.TahasilID=0;
        } 
        if( this.contactDetails.StudentLocalTahsilID ==null || this.contactDetails.StudentLocalTahsilID ==undefined)
        {
          this.contactDetails.StudentLocalTahsilID=0;
        } 
        if(this.contactDetails.StudentLocalCity == "" || this.contactDetails.StudentLocalCity ==null || this.contactDetails.StudentLocalCity ==undefined)
        {
          this.HelperService.showWarningMessage("Enter City");
            return;
        } 
        if(this.contactDetails.ForeignCountryName ==null || this.contactDetails.ForeignCountryName ==undefined)
        {
          this.contactDetails.ForeignCountryName="";
        } 
        this.contactDetails.CreatedLoginID=this.Configuration.CreatedLoginID;
        this.contactDetails.UpdatedLoginID=this.Configuration.UpdatedLoginID;
        this.contactDetails.PhotoPath ="a";
        this.contactDetails.SignPath ="a";
        this.saveRecordTabSecondDisabled=true;
        if(this.contactDetails.PreStudAddrID == null || this.contactDetails.PreStudAddrID == 0) {
            this.contactDetails.PreStudAddrID = 0;
            this.ContactdetailsService.save(this.contactDetails)
            .subscribe(value => {
               //this.onSuccessSave();
               //this.saveRecordTabSecondDisabled=false;
               this.saveDocTab();
            },
              err => {
                this.errorMessage=this.HelperService.getErrorMessage(err);
                this.HelperService.showSuccessMessage("Not Saved.");    
                this.saveRecordTabSecondDisabled=false;
              },
              () => {
              });

        }else {
          this.ContactdetailsService.update(this.contactDetails)
            .subscribe(value => {
              //this.onSuccessUpdate();
              this.saveDocTab();
              this.saveRecordTabSecondDisabled=false;
            },
              err => {
                this.errorMessage=this.HelperService.getErrorMessage(err);
                this.HelperService.showSuccessMessage("Not Saved.");    
                this.saveRecordTabSecondDisabled=false;
              },
              () => {
              });
        }
  }
  onSuccessSave() {
    this.HelperService.showSuccessMessage("Student Information Saved Successfully.");    
  }
  onSuccessUpdate() {
    this.HelperService.showSuccessMessage("Student Information Updated Successfully.");    
  }
 
  nextTab(i){
    
    this.parentApi.callParentMethod('1',i,"personalinfromation");
  }
  backTab(i){
    this.parentApi.callParentMethod('2',i,"personalinfromation");
  }

  onLnameChange(){

  }
  onFnameChange(){

  }
  onMnameChange(){

    this.personalInformationForm.StudentName=this.personalInformationForm.StudentLastName+' '+this.personalInformationForm.StudentFirstName+' '+this.personalInformationForm.StudentMiddleName;

  }
  onchange(){
      this.birthdate=this.personalInformationForm.StudentBirthDate;
         var timeDiff = Math.abs(Date.now() -this.birthdate);
           var newage = Math.floor((timeDiff / (1000 * 3600 * 24))/365);
    this.personalInformationForm.age= newage; 

  }
  





//tab2

filldropdowns(){
  this.religionService.getAllReligion()
    .subscribe((data: Religion[]) => this.ReliginData = data,
      error => {
        alert(error);
      },
      () => {
        this.castService.getAllCaste()
          .subscribe((data: BasicCaste[]) => this.CasteData = data,
            error => {
              alert(error);
            },
            () => {
               this.reservationCategoryService.getAllReservationcategoryList()
                      .subscribe((data: Reservationcategory[]) => this.categories = data,
                        error => {
                          alert(error);
                        },
                        () => {
                          this.PersonalinformationService.GetAllMinorityList()
                                              .subscribe((data: MinorityDataList[]) => this.TempMinorityData = data,
                                                error => {
                                                  alert(error);
                                                },
                                                () => {
                                                  this.MinorityData = this.TempMinorityData;


                                                  debugger
                                            this.PersonalinformationService.GetStudentUniversityType()
                                            .subscribe((data: PreviousCollegeList[]) => this.datasource = data,
                                              error => {
                                                alert(error);
                                              },
                                              () => {
                                                this.PreviousCollegeDtl = this.datasource; 

                                                  this.SocialreservationService.GetSocialReservationInfo(this.Configuration.StudentID)
                                                .subscribe((data: preSocialReservationInfo[]) => this.datasource = data,
                                                  error => {
                                                    alert(error);
                                                  },
                                                  () => {
                                                    this.SocialResData = this.datasource; 
                                                    });
                                                  });

                                                });
                        });
            });
      });
}
GetBasicReligionList() {
  this.religionService.getAllReligion()
    .subscribe((data: Religion[]) => this.ReliginData = data,
      error => {
        alert(error);
      },
      () => {
      });
}
getAllCasteList() {
  this.castService.getAllCaste()
    .subscribe((data: BasicCaste[]) => this.CasteData = data,
      error => {
        alert(error);
      },
      () => {
        ;
        if (this.CasteData.length > 0 && this.Configuration.StudentID == 0) {
        }
      });
}
getAllSubCasteList() {
  this.castService.getAllSubCaste()
    .subscribe((data: BasicSubCaste) => this.SubCasteData = data,
      error => {
        alert(error);
      },
      () => {

      });
}




registeredForVoterListToggler() {
  if (this.personalInformationForm2 == undefined) {
    return;
  }
  if (this.personalInformationForm2.RegisteredForVoter == true) {
    this.DisabledVoterID = false;
  } else {
    this.DisabledVoterID = true;
  }
}
nationalityToggler() {

  if (this.personalInformationForm2.NationalityFlag == "I") {
    this.personalInformationForm2.VisaNumber = "";
    this.personalInformationForm2.VisaValidity = null;
    this.DisabledVisa = true;
    this.hideVisa = false;
  } else {
    this.DisabledVisa = false;
    this.hideVisa = true;
  }
}
selectionChangedHandlerMinority(e) {
  
  var MinorityID = e.value;
  if (MinorityID == null || MinorityID == undefined) {
    return;
  }
  this.Minoritydisable = false;
  this.objmin = [];
  for (var i = 0; i < this.TempMinorityData.length; i++) {
    if (this.personalInformationForm2.MinorityTypeID == this.TempMinorityData[i].MinorityCode) {
      this.objMinority = [];
      this.objMinority.MinorityID = this.TempMinorityData[i].MinorityID;
      this.objMinority.MinorityDescription = this.TempMinorityData[i].MinorityDescription;
      this.objMinority.MinorityCode = this.TempMinorityData[i].MinorityCode;
      this.objMinority.MinorityType = this.TempMinorityData[i].MinorityType;
      this.objmin.push(this.objMinority);
    }
  }
  this.MinorityData = this.objmin;
}
MinorityTypeToggler() {
  if (this.personalInformationForm2 == undefined) {
    return;
  }
  if (this.personalInformationForm2.MinorityTypeID == undefined) {
    return;
  }
}

cancelClick() {
  this.SaveBtnDisabled = false;

}
selectionChangedHandlerCaste(e) {
  this.StudentCastID = e.value;
  this.othercastdisable=true;
  for(var i=0;i<this.CasteData.length;i++){
    if(this.CasteData[i].CasteID==e.value){
      this.castname=this.CasteData[i].CasteDescription;
      
    }
  }
  if(this.castname=="Other"){
    this.othercastdisable=false;
  }
  var CasteID = e.value;
  this.subcastedisable = false;
  
}
selectionChangedHandlerCategory(e) {
  var ReservationCategoryID = e.value;
  this.ReservationCategoryID = e.value;
  this.castdisable=false;
  if (ReservationCategoryID == null || ReservationCategoryID == undefined) {
    return;
  }

  this.subcastedisable = false;
  this.castService.getCasteByeReservationCategoryID(ReservationCategoryID)
    .subscribe((data: BasicCaste) => this.CasteData = data,
      error => {
        alert(error);
      },
      () => {
      }); 
  }
  getdata(){
    this.EducationaldetailService.GetPreStudentOtherInfoWithCourseType(this.Configuration.StudentID,this.CourseTypeID)
    .subscribe((data: preStudentAddressInfoEdu[]) => this.dataSourcetemp = data,
      error => {
        alert(error);
      },
      () => {
        this.dataSource=[];
        for(var i=0;i<this.dataSourcetemp.length;i++){
          if(this.dataSourcetemp[i].PreviousCategory != "Other"){
          
              this.TempEdudata =[];
              this.TempEdudata = this.dataSourcetemp[i];
              this.dataSource.push(this.TempEdudata);
            
          }
          
        }
        for (var i = 0; i < this.dataSource.length; i++) {
          if (this.dataSource[i].PreviousCategory == "SSC")  {
            this.tenYear=this.dataSource[i].PreviousExamYear;
          }
        }
        
      }); 
  }
  getEdu(){
    this.getdata();
  }
  getDoc(){
    this.getdatadoc();
  }
  getdatadoc() { debugger
    this.CommondocumentsService.GetPreStudentDocumentsList(this.Configuration.StudentID)
      .subscribe((data: Documents[]) => this.dataSourceDoc = data,
        error => {
          alert(error);
        },
        () => {
          if(this.dataSourceDoc.length > 0){
            //this.CompDocs = this.dataSourceDoc ;
            this.CommonDocumentStatusFlag = this.dataSourceDoc[0].CommonDocumentStatusFlag;        
            this.ApprovedFlag = this.dataSourceDoc[0].ApprovedFlag;        
             
          }
          for (var i = 0; i < this.dataSourceDoc.length; i++) {
            if (this.dataSourceDoc[i].checkedValue == "Y") {
              this.dataSourceDoc[i].chk = true;
            } else {
              this.dataSourceDoc[i].chk = false;
            }
          }
          this.CommondocumentsService.GetCompDocumentsForAdmission(this.Configuration.StudentID)
          .subscribe((data: Documents[]) => this.CompDocs = data,
            error => {
              alert(error);
            },
            () => {
              this.dashboardService.getFormByStudentID(this.Configuration.StudentID)
              .subscribe((data: Hallticket[]) => this.form1 = data,
                error => {
                  alert(error);
                },
                () => {
                  this.profilelink=this.form1.Message;
                }
              );
            });
        });

 
  }
  onValueChangedCourseType(e){
    this.CourseTypeID=e.value;
  }  
  saveCourseType(){
    if(this.CourseTypeID ==0 || this.CourseTypeID ==undefined || this.CourseTypeID ==null){
      this.HelperService.showWarningMessage("Please Select Program Type");
      return;
    }
    this.ContactdetailsService.GetInsertCourseType(this.Configuration.StudentID,this.CourseTypeID)
    .subscribe((data: CourseType[]) => this.data = data,
      error => {
        alert(error);
      },
      () => {
        this.getdata();
        this.HelperService.showSuccessMessage("Program Type Saved Successfully.");    
      });
  }
  selectionChangedHandlerLocalState(e) {
    var StateID = e.value;
    if(StateID == null || StateID == undefined){
      return;
    }
    this.DistrictService.getDistrictByStateID(StateID)
    .subscribe((data: District[]) => this.districtlocal = data,
      error => {
        alert(error);
      },
      () => {
      });
  }
  selectionChangedHandlerLocalDistrict(e){
    var DistrictID = e.value;
    if(DistrictID == null || DistrictID == undefined){
      return;
    }
    this.TahsilService.getTahsilByDistrictID(DistrictID)
    .subscribe((data: Tahsil[]) => this.tahsillocal = data,
      error => {
        alert(error);
      },
      () => {
      }); 
  } 
  selectionChangedHandler(e) {
        this.DeleteBtnDisabled = false;
        if (this.Configuration.StudentProfileLock == "Y") {
          return;
        }
        var component = e.component;
        if (!component.clickCount)
          component.clickCount = 1;
        else
          component.clickCount = component.clickCount + 1;
        if (component.clickCount == 1) {
          component.lastClickTime = new Date();
          setTimeout(function () { component.lastClickTime = 0; component.clickCount = 0; }, 350);
        }
        else if (component.clickCount == 2) {
          const date: Date = new Date();
          if ((Number(date) - component.lastClickTime) < 300) {
            this.popupTitleedu = this.LanguageLabel.AddUpdatePreviousExamDetails + " - " + e.data.PreviousCategory;
            if ((e.data.PreviousCategory === "HSC") || (e.data.PreviousCategory == "Diploma")) {
              var filterData = this.dataSource.filter(data => {
                return ((data.PreviousCategory == "SSC") && (data.StudentOtherInfoID == 0));
              });
              if ((filterData) && (filterData.length > 0)) {
                this.HelperService.showWarningMessage("Please fill SSC Educational details");
                return;
              }
            }
            if ((e.data.PreviousCategory === "UG")) {
              var filterXIIData = this.dataSource.filter(data => {
                return ((data.PreviousCategory == "HSC" || data.PreviousCategory == "Diploma") && (data.StudentOtherInfoID == 0));
              });
              if ((filterXIIData) && (filterXIIData.length > 1)) {
                this.HelperService.showWarningMessage("Please fill  HSC or Diploma Educational details");
                return;
              }
            }
  
            if ((e.data.PreviousCategory === "PG")) {
              var filterUGData = this.dataSource.filter(data => {
                return ((data.PreviousCategory == "UG") && (data.StudentOtherInfoID == 0));
              });
              if ((filterUGData) && (filterUGData.length > 0)) {
                this.HelperService.showWarningMessage("Please fill UG Educational details");
                return;
              }
            }
  
            if ((e.data.PreviousCategory === "MPhil")) {
              var filterPGData = this.dataSource.filter(data => {
                return ((data.PreviousCategory == "PG") && (data.StudentOtherInfoID == 0));
              });
              if ((filterPGData) && (filterPGData.length > 0)) {
                this.HelperService.showWarningMessage("Please fill PG Educational details");
                return;
              }
            }
            
            this.educationalDetailData=null;
            e.data.tenYear = this.tenYear
            this.educationalDetailData = e.data;
            this.popupVisibleedu=true;
          }
          component.clickCount = 0;
          component.lastClickTime = 0;
        }
     
    }
    onCloseButton() {
      this.popupVisible = false;
      this.popupVisibleedu=false;
      this.DeleteBtnDisabled = true;
      this.getdata();
    }
    onSuccessDelete() {
      this.HelperService.showSuccessMessage("Educational Details Deleted Successfully.");    
    }
    reset() {
      this.getdata();
    }

    saveDocTab() {
      debugger;
      for (var i = 0; i <  this.dataSourceDoc.length; i++) {
        if (this.dataSourceDoc[i].chk == false &&  this.dataSourceDoc[i].CompOptFlag == "Y") {
          this.HelperService.showWarningMessage("Please Upload " +  this.dataSourceDoc[i].DocumentName + "");
          return false;
        }
      }
      for (var j = 0; j < this.CompDocs.length; j++) {
        for (var i = 0; i <  this.dataSourceDoc.length; i++) {
          if (this.CompDocs[j].DocumentID ==  this.dataSourceDoc[i].DocumentID) {
            if ( this.dataSourceDoc[i].chk == false) {
              this.HelperService.showWarningMessage("Please Upload " +  this.dataSourceDoc[i].DocumentName + "");
              return false;
            }
          }
        }
      }
      this.CommondocumentsService.GetProfileLockStatusForAdmissionForm(this.Configuration.StudentID) //6123          
        .subscribe((data: UsertDetailsStatus[]) => {
          this.data = data;
        },
          error => {
            alert(error);
          },
          () => {
            if (
             this.data[0].CommonDocumentStatusFlag == "Y" &&
              this.data[0].PrevEducationStatusFlag == "Y" 
            ) {
              this.popupVisible1 =true;
              this.msg="Do you want to lock your Profile?";
            
            } else {
              /* this.popupVisible2 =true;
              this.msg="Your Profile is incomplete can't Submit";
              return; */
              this.HelperService.showWarningMessage("Your Profile is incomplete can't Submit");
              return;
            }
          });
    }
    ProfilelockconfirmYes(e){
      this.YesBtnDisabled=true;
            this.CommondocumentsService.getupdateprofilelock(this.Configuration.StudentID) //6123          
            .subscribe((data: UsertDetailsStatus[]) => {
              this.dataSource = data;
              this.HelperService.showSuccessMessage("Your Profile is Locked Successfully");
               this.Configuration.StudentProfileLock="Y";
              },
              error => {
                alert(error);
              },
              () => {
                this.YesBtnDisabled=false;
              });
  }
  gotoadmission(){
    if(this.Configuration.StudentProfileLock!="Y"){
      this.HelperService.showWarningMessage("Your Profile Not Locked");
      return;
    }else{
      this.Router.navigate(['/studentportal/courseselectioncollege']);
      this.YesBtnDisabled=false;
      this.popupVisible1 =false; 
    }
  }
  handleFileUpload(messageResponse: string) {debugger
    this.HelperService.showSuccessMessage("File uploaded successfully.");
    this.getdatadoc();
  }

  handleFileUploadError() {
    this.HelperService.showSuccessMessage("File upload not successful.");
  }

  onEditorPreparingDoc(e) {
    if (e.parentType === "dataRow")
    {
      if (e.dataField === "chk")
      {
       
          e.editorOptions.readOnly = true;
        
      }
    }
  }
  viewPdfDocument(data) {
    debugger
    if (data.key.DocumentPath.length > 0) {
      this.documentId = data.key.DocumentID;
      this.urlDoc = data.key.DocumentPath ;
      this.openWindowDoc();
    }
  }
  removeDocument(data) {
    this.RemoveFileData =data;
    this.popupVisible3 = true; 
  }
  RemoveFileconfirmOK() {debugger
    this.data1 = this.RemoveFileData;
    if (this.data1.key.DocumentPath.length > 0) {
      var deleteDocument = {
        "StudentDocumentID": this.data1.key.StudentDocumentID,
        "UpdatedLoginID": this.data1.key.UpdatedLoginID,
        "StudentID": this.Configuration.StudentID,
      }
     
      this.CommondocumentsService.deleteUploadedDocument(deleteDocument)    
        .subscribe((data: UsertDetailsStatus) => {
          
          this.popupVisible3 = false; 
          this.getdatadoc();
          this.HelperService.showSuccessMessage("File Deleted Successfully.");
        },
          error => {
            this.popupVisible3 = false; 
            alert(error);
          },
          () => {
           
          });
    }
    
  }
  
  onCloseButtonDoc() {
    this.popupVisible3 = false; 
  }
  onSuccessProfileLock() {
    this.HelperService.showSuccessMessage("Your Profile is Locked Successfully.");
    
  }
  openWindowDoc() {
    this.popupTitleViewDoc = this.LanguageLabel.View;
    this.errorMessage = [];
    this.popupVisibleDoc = true;
  }
  popupHidingDoc(e) {
    this.errorMessage = [];
  };
  ProfilelockconfirmNo(){
    this.popupVisible2 =true;
    this.msg="You need to lock Profile from Dashboard before Application Form Submission";
    this.popupVisible1 =false;
  }
  confirmOK(){
    this.popupVisible2 =false;
    //this.Router.navigate(['/studentportal/dashboard']);
  }
  popupHiding(e) {
    this.showButton = true;
  }; 
  popupHidingedu(e) {
    this.showButton = true;
  }; 
  popupHidingConfirm(e) {
    this.errorMessage = [];
  };
  printpreviewclick(){
    this.dashboardService.getFormByStudentID(this.Configuration.StudentID)
              .subscribe((data: Hallticket[]) => this.form1 = data,
                error => {
                  alert(error);
                },
                () => {
                  this.profilelink=this.form1.Message;
                }
     );
  }
}

